import { CommApiInstance } from "Utils/CommApiInstance";


const AppStrtApi = async (
    pageCd:string
) => {
    return await CommApiInstance.post(`app/BBCAPP/app_strt`,{
        apiBody: {
            pageCode: pageCd
        }
        
    })
    .then((Resp) => Resp.data);
}

export default AppStrtApi;